import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'components/Common/MasterComponents'
import { CheckFilledIcon } from 'components/Common/Icons'
import RecognizedProduct from '../RecognizedProduct'
import { Title, List, Subtitle, MobileFooter } from '../_styles'
import { Product } from 'api/schemas'

interface RecognizedStateProps {
  product: Product
  onIncorrectClick: () => void
  onImageClick: (images: string[]) => void
  renderImageCounter: (count: number) => React.ReactNode
  images: string[]
  testIdPrefix?: string
}

const RecognizedState: FC<RecognizedStateProps> = ({
  product,
  onIncorrectClick,
  onImageClick,
  renderImageCounter,
  images,
  testIdPrefix,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Title>
        <CheckFilledIcon size={20} color={'var(--color-green)'} />
        <span>{t('capturedWines.dialog.updateImages.wineRecognized')}</span>
        <Button
          $size='S'
          $type='secondary'
          $variant='flexible'
          onClick={onIncorrectClick}
          data-testid={
            testIdPrefix ? `${testIdPrefix}-not-correct-button` : undefined
          }
        >
          {t('capturedWines.dialog.updateImages.notCorrect')}
        </Button>
      </Title>
      <Subtitle>
        {t('capturedWines.dialog.updateImages.recognizedDesc')}
      </Subtitle>
      <List>
        <RecognizedProduct
          images={images}
          onImageClick={onImageClick}
          renderImageCounter={renderImageCounter}
          product={product}
          testIdPrefix={testIdPrefix}
        />
      </List>
      <MobileFooter>
        <Button
          $size='S'
          $type='secondary'
          $variant='text'
          onClick={onIncorrectClick}
          data-testid={
            testIdPrefix
              ? `${testIdPrefix}-not-correct-button-mobile`
              : undefined
          }
        >
          {t('capturedWines.dialog.updateImages.notCorrect')}
        </Button>
      </MobileFooter>
    </>
  )
}

export default RecognizedState
